import { Flex } from '../../containers/Flex/Flex.component';

export const Circle = ({ size }: { size: number }) => (
  <Flex width={size} height={size} alignItems={'center'} justifyContent={'center'}>
    <svg viewBox="0 0 100 100" width={6} height={6} xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="50" />
    </svg>
  </Flex>
);
